<template>
  <page-wrapper :title="title">
    <div class="feature-introdiction-container">
      <sc-button
        variant="primary"
        class="mb-4"
        :route="{ name: 'FeatureIntroductionCreatePage' }"
      >เพิ่ม Feature Introduction</sc-button>
      <FeatureIntroductionListItem
        v-for="introductionItem in fetureIntroductionList"
        :key="introductionItem.id"
        :title="introductionItem.title"
        :platform="introductionItem.platform"
        :version="introductionItem.version"
        :created_at="introductionItem.created_at"
        :image_url="introductionItem.image_url"
      />
      <div class="wrapper text-right padding-adjust">
        <el-pagination
          :page-size="5"
          :total="total"
          :current-page="queryParams.page"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { Pagination } from "element-ui";

import FeatureIntroductionListItem from "../components/FeatureIntroductionListItem";

export default {
  components: {
    PageWrapper,
    ScButton,
    FeatureIntroductionListItem,
    "el-pagination": Pagination
  },
  data() {
    const title = "Feature Introduction";
    const fetureIntroductionList = [];
    const total = 12;

    return {
      title,
      total,
      fetureIntroductionList
    };
  },
  methods: {
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    }
  },
  computed: {
    queryParams() {
      return {
        page: parseInt(this.$route.query.page) || 1
      };
    }
  },
  watch: {
    async "$route.query"(query) {
      await this.setupData();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.feature-introdiction-container {
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/features/communications/modules/featureIntroduction/pages/FeatureIntroductionListPage.vue